import {z} from 'zod'

const ProspectsByCapacitySchema = z
    .object({
        capacity_bucket: z.string(),
        prospect_count: z.number(),
    })
    .transform(({capacity_bucket, prospect_count}) => ({
        capacityBucket: capacity_bucket,
        prospectCount: prospect_count,
    }))

const LifetimeByCapacitySchema = z
    .object({
        capacity_bucket: z.string(),
        total_lifetime_giving: z.string(),
    })
    .transform(({capacity_bucket, total_lifetime_giving}) => ({
        capacityBucket: capacity_bucket,
        totalLifetimeGiving: total_lifetime_giving,
    }))

const CampaignGapRowSchema = z
    .object({
        gift_size: z.number(),
        number_required: z.nullable(z.number()),
        number_identified: z.number(),
        sort_order: z.number(),
        gap: z.nullable(z.number()),
        status: z.string(),
    })
    .transform(({gift_size, number_required, number_identified, sort_order, gap, status}) => ({
        giftSize: gift_size,
        numberRequired: number_required,
        numberIdentified: number_identified,
        sortOrder: sort_order,
        gap,
        status,
    }))

export const DashboardDataSchema = z
    .object({
        prospects_by_capacity: z.array(ProspectsByCapacitySchema),
        lifetime_giving_by_capacity: z.array(LifetimeByCapacitySchema),
        campaign_gap: z.array(CampaignGapRowSchema),
        share_of_purse: z.nullable(z.string()),
        sec_insider_count: z.number(),
        foundation_prospect_count: z.number(),
    })
    .transform(
        ({
            prospects_by_capacity,
            lifetime_giving_by_capacity,
            campaign_gap,
            share_of_purse,
            sec_insider_count,
            foundation_prospect_count,
        }) => ({
            prospectsByCapacity: prospects_by_capacity,
            lifetimeGivingByCapacity: lifetime_giving_by_capacity,
            campaignGap: campaign_gap,
            shareOfPurse: share_of_purse,
            secInsiderCount: sec_insider_count,
            foundationProspectCount: foundation_prospect_count,
        }),
    )

export type DashboardData = z.infer<typeof DashboardDataSchema>
